export default "__VITE_ASSET__d8ae75cb__"